import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "order-status-info" }
const _hoisted_2 = { class: "order-status-info__title" }
const _hoisted_3 = { class: "order-status-rules" }
const _hoisted_4 = { class: "order-status-rules__rule order-status-rules__rule--header" }
const _hoisted_5 = { class: "order-status-rules__rule-layout" }
const _hoisted_6 = { class: "order-status-rules__condition-row order-status-rules__condition-row--header" }
const _hoisted_7 = { class: "order-status-rules__result-header" }
const _hoisted_8 = ["draggable", "onDragstart", "onDragover", "onDragleave", "onDrop"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "order-status-rules__rule-layout" }
const _hoisted_11 = { class: "order-status-rules__conditions" }
const _hoisted_12 = { class: "order-status-rules__join-label" }
const _hoisted_13 = { class: "order-status-rules__select-input" }
const _hoisted_14 = {
  key: 1,
  class: "order-status-rules__readonly-text"
}
const _hoisted_15 = {
  key: 2,
  class: "order-status-rules__error-text"
}
const _hoisted_16 = { class: "order-status-rules__select-input" }
const _hoisted_17 = {
  key: 1,
  class: "order-status-rules__readonly-text"
}
const _hoisted_18 = {
  key: 2,
  class: "order-status-rules__error-text"
}
const _hoisted_19 = {
  key: 0,
  class: "order-status-rules__readonly-text"
}
const _hoisted_20 = {
  key: 1,
  class: "order-status-rules__no-value"
}
const _hoisted_21 = { class: "order-status-rules__select-input" }
const _hoisted_22 = ["value", "placeholder", "onChange"]
const _hoisted_23 = ["value", "placeholder", "onChange"]
const _hoisted_24 = {
  key: 3,
  class: "order-status-rules__error-text"
}
const _hoisted_25 = ["aria-label", "onClick"]
const _hoisted_26 = { class: "order-status-rules__result-cell" }
const _hoisted_27 = { class: "order-status-rules__actions" }
const _hoisted_28 = ["aria-label", "onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "order-status-fallback" }

import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import DragHandle from '@/corePagesModule/components/DragHandle.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';
import { useNativeDragReorder } from '@/corePagesModule/composables/useNativeDragReorder';
import { i18n } from '@/i18n';
import OrderStatusFormSelectInput from '@/unmatchedOrderModule/components/OrderStatusFormSelectInput.vue';
import { ref, watch } from 'vue';
import { ConditionOperators, ConditionValueTypes } from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import type {
  ConditionOperator,
  ConditionValueType,
  ImportOrderStatusCondition,
  ImportOrderStatusRule,
} from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import SelectableField from '../SelectableField.vue';
import ConditionDateInput from './ConditionDateInput.vue';

const RULE_ID_PREFIX = 'ROS';
const CONDITION_ID_PREFIX = 'COS';
const RANDOM_ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const FALLBACK_STATUS_SELECT_INDEX = 999;
const DRAG_HANDLE_SELECTOR = '.drag-handle';


export default /*@__PURE__*/_defineComponent({
  __name: 'InputExcelOrderStatusInfo',
  props: {
    suggestions: {},
    rules: {},
    fallbackStatus: {},
    isEditing: { type: Boolean }
  },
  emits: ["update:rules", "update:fallbackStatus"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const DEFAULT_ORDER_STATUS = OrderStatus.ApprovedAwaitingDeliveryDate;
const SELECTABLE_ORDER_STATUS = [
  OrderStatus.ApprovedAwaitingDeliveryDate,
  OrderStatus.QuantityConfirmed,
  OrderStatus.DeliveryDateConfirmed,
  OrderStatus.Confirmed,
  OrderStatus.Delivered,
  OrderStatus.DeliveryDelayed,
];

const props = __props;

const emits = __emit;

const conditionValueTypeLabels: Record<Exclude<ConditionValueType, 'none'>, string> = {
  text: t('文字列'),
  number: t('数値'),
  date: t('日付'),
};

const conditionOperatorLabels: Record<ConditionOperator, string> = Object.fromEntries(
  ConditionOperators.map((operator) => [operator, t(`condition-op-${operator}`)])
) as Record<ConditionOperator, string>;

const conditionOperatorSuggestions = ConditionOperators.map((operator) => conditionOperatorLabels[operator]);
const conditionValueTypeSuggestions = ConditionValueTypes.map((valueType) => conditionValueTypeLabels[valueType]);
const comparableConditionValueTypeSuggestions = ConditionValueTypes.filter((valueType) => valueType !== 'text').map(
  (valueType) => conditionValueTypeLabels[valueType]
);
const containsConditionValueTypeSuggestions = ConditionValueTypes.filter((valueType) => valueType !== 'date').map(
  (valueType) => conditionValueTypeLabels[valueType]
);

/**
 * 大小比較を行う条件かどうかを判定する
 * @param operator - 条件演算子
 * @returns 大小比較を行う場合true
 */
const isComparableOperator = (operator: ConditionOperator): boolean => ['gt', 'gte', 'lt', 'lte'].includes(operator);

/**
 * 部分一致を行う条件かどうかを判定する
 * @param operator - 条件演算子
 * @returns 部分一致を行う場合true
 */
const isContainsOperator = (operator: ConditionOperator): boolean => ['contains', 'not_contains'].includes(operator);

/**
 * 条件演算子に応じた入力種別候補を取得する
 * @param operator - 条件演算子
 * @returns 条件値の入力種別候補
 */
const getConditionValueTypeSuggestions = (operator: ConditionOperator): string[] => {
  if (isComparableOperator(operator)) return comparableConditionValueTypeSuggestions;
  if (isContainsOperator(operator)) return containsConditionValueTypeSuggestions;
  return conditionValueTypeSuggestions;
};

/**
 * RuleとConditionへのID付与のためのランダム文字列を取得する
 * @param length - 文字列の長さ
 */
const generateRandomString = (length = 16): string => {
  const values = new Uint32Array(length);

  crypto.getRandomValues(values);

  return Array.from(values, (value) => RANDOM_ID_CHARS[value % RANDOM_ID_CHARS.length]).join('');
};

/**
 * デフォルトのRuleを取得
 */
const createDefaultRule = (): ImportOrderStatusRule => ({
  id: RULE_ID_PREFIX + generateRandomString(),
  conditions: [createDefaultCondition()],
  result: DEFAULT_ORDER_STATUS,
});

/**
 * デフォルトのConditionを取得
 */
const createDefaultCondition = (): ImportOrderStatusCondition => ({
  id: CONDITION_ID_PREFIX + generateRandomString(),
  header: '',
  operator: 'equals',
  valueType: 'text',
  value: '',
  validateError: {
    header: 'none',
    value: 'none',
  },
});

/**
 * ルールをpropsと切り離して複製する
 * @param rules - 複製元のルール
 * @returns 複製したルール
 */
const cloneRules = (rules: ImportOrderStatusRule[]): ImportOrderStatusRule[] =>
  rules.map((rule) => ({
    ...rule,
    conditions: rule.conditions.map((condition) => {
      const shouldNormalizeComparableValue = isComparableOperator(condition.operator) && condition.valueType === 'text';
      const shouldNormalizeContainsValue = isContainsOperator(condition.operator) && condition.valueType === 'date';

      return {
        ...condition,
        valueType: shouldNormalizeComparableValue ? 'number' : shouldNormalizeContainsValue ? 'text' : condition.valueType,
        value: shouldNormalizeComparableValue ? null : shouldNormalizeContainsValue ? String(condition.value ?? '') : condition.value,
        validateError: condition.validateError ?? {
          header: 'none',
          value: 'none',
        },
      };
    }),
  }));

const rulesForDrag = ref<ImportOrderStatusRule[]>(cloneRules(props.rules));

watch(
  () => props.rules,
  (rules) => {
    rulesForDrag.value = cloneRules(rules);
  },
  { deep: true }
);

/**
 * ルール全体の変更を親へ通知する
 * @param rules - 更新後のルール
 */
const emitRules = (rules: ImportOrderStatusRule[]): void => {
  const nextRules = cloneRules(rules);
  rulesForDrag.value = nextRules;
  emits('update:rules', cloneRules(nextRules));
};

/**
 * 演算子の表示値を取得する
 * @param operator - 変換する演算子
 */
const getOperatorDisplayValue = (operator: ConditionOperator): string => conditionOperatorLabels[operator];

/**
 * 条件演算子の表示名から内部値を取得する
 * @param displayValue - 条件演算子の表示名
 * @returns 条件演算子
 */
const getOperatorByDisplayValue = (displayValue: string): ConditionOperator => {
  return ConditionOperators.find((operator) => conditionOperatorLabels[operator] === displayValue) ?? 'equals';
};

/**
 * 値入力が不要な条件かどうかを判定する
 * @param operator - 条件演算子
 * @returns 値入力が不要な場合true
 */
const isNoValueOperator = (operator: ConditionOperator): boolean => operator === 'is_empty' || operator === 'is_not_empty';

/**
 * 条件値の入力種別表示名を取得する
 * @param valueType - 条件値の入力種別
 * @returns 表示名
 */
const getValueTypeDisplayValue = (valueType: ConditionValueType): string => {
  if (valueType === 'none') return '';
  return conditionValueTypeLabels[valueType];
};

/**
 * 条件値の入力種別表示名から内部値を取得する
 * @param displayValue - 表示名
 * @returns 条件値の入力種別
 */
const getValueTypeByDisplayValue = (displayValue: string): Exclude<ConditionValueType, 'none'> => {
  return ConditionValueTypes.find((valueType) => conditionValueTypeLabels[valueType] === displayValue) ?? 'text';
};

/**
 * 条件値の表示文字列を取得する
 * @param condition - 条件
 * @returns 条件値の表示文字列
 */
const getConditionValueDisplayValue = (condition: ImportOrderStatusCondition): string => {
  if (isNoValueOperator(condition.operator)) return '--';
  if (condition.value == null) return '';
  return String(condition.value);
};

/**
 * 条件値の入力エラー文言を取得する
 * @param condition - 条件
 * @returns 条件値の入力エラー文言
 */
const getConditionValueErrorMessage = (condition: ImportOrderStatusCondition): string => {
  if (condition.validateError.value === 'notEmpty') return t('記入必須です');
  return '　';
};

/**
 * 新規ルールを追加
 */
const addRule = (): void => {
  if (!props.isEditing) return;

  emitRules([...rulesForDrag.value, createDefaultRule()]);
};

/**
 * 新規コンディションを追加
 * @param ruleIndex - 親ルールのIndex
 */
const addCondition = (ruleIndex: number): void => {
  if (!props.isEditing) return;

  emitRules(
    rulesForDrag.value.map((rule, index) =>
      index === ruleIndex ? { ...rule, conditions: [...rule.conditions, createDefaultCondition()] } : rule
    )
  );
};

/**
 * ルールを削除
 * @param index - 削除するルールのIndex
 */
const removeRule = (index: number): void => {
  if (!props.isEditing) return;

  emitRules(rulesForDrag.value.filter((_, ruleIndex) => ruleIndex !== index));
};

/**
 * コンディションの削除
 * @param ruleIndex - 親ルールのIndex
 * @param conditionIndex - 削除するConditionのIndex
 */
const removeCondition = (ruleIndex: number, conditionIndex: number): void => {
  if (!props.isEditing) return;

  const nextRules = rulesForDrag.value.flatMap((rule, index) => {
    if (index !== ruleIndex) return [rule];

    const conditions = rule.conditions.filter((_, index) => index !== conditionIndex);
    return conditions.length === 0 ? [] : [{ ...rule, conditions }];
  });

  emitRules(nextRules);
};

/**
 * 条件を差し替える
 * @param ruleIndex - 更新対象のルールindex
 * @param conditionIndex - 更新対象の条件index
 * @param condition - 差し替える条件
 */
const updateCondition = (ruleIndex: number, conditionIndex: number, condition: ImportOrderStatusCondition): void => {
  if (!props.isEditing) return;

  emitRules(
    rulesForDrag.value.map((rule, index) =>
      index === ruleIndex
        ? {
            ...rule,
            conditions: rule.conditions.map((currentCondition, index) => (index === conditionIndex ? condition : currentCondition)),
          }
        : rule
    )
  );
};

/**
 * 条件を部分更新する
 * @param ruleIndex - 更新対象のルールindex
 * @param conditionIndex - 更新対象の条件index
 * @param patch - 更新する値
 */
const updateConditionByIndex = (ruleIndex: number, conditionIndex: number, patch: Partial<ImportOrderStatusCondition>): void => {
  if (!props.isEditing) return;

  const currentCondition = rulesForDrag.value[ruleIndex]?.conditions[conditionIndex];
  if (!currentCondition) return;

  updateCondition(ruleIndex, conditionIndex, {
    ...currentCondition,
    ...patch,
    validateError: {
      ...currentCondition.validateError,
      ...patch.validateError,
      header: patch.header != null ? 'none' : currentCondition.validateError.header,
      value: patch.value !== undefined ? 'none' : currentCondition.validateError.value,
    },
  });
};

/**
 * 条件演算子を更新する
 * @param ruleIndex - 更新対象のルールindex
 * @param conditionIndex - 更新対象の条件index
 * @param operator - 条件演算子
 */
const updateConditionOperator = (ruleIndex: number, conditionIndex: number, operator: ConditionOperator): void => {
  if (!props.isEditing) return;

  const currentCondition = rulesForDrag.value[ruleIndex]?.conditions[conditionIndex];
  if (!currentCondition) return;

  const condition: ImportOrderStatusCondition = {
    ...currentCondition,
    operator,
    validateError: {
      ...currentCondition.validateError,
      value: 'none',
    },
  };

  if (isNoValueOperator(operator)) {
    condition.valueType = 'none';
    condition.value = null;
  } else if (condition.valueType === 'none') {
    condition.valueType = 'text';
    condition.value = '';
  } else if (isComparableOperator(operator) && condition.valueType === 'text') {
    condition.valueType = 'number';
    condition.value = null;
  } else if (isContainsOperator(operator) && condition.valueType === 'date') {
    condition.valueType = 'text';
    condition.value = String(condition.value ?? '');
  }

  updateCondition(ruleIndex, conditionIndex, condition);
};

/**
 * 条件値の入力種別を更新する
 * @param ruleIndex - 更新対象のルールindex
 * @param conditionIndex - 更新対象の条件index
 * @param displayValue - 入力種別の表示名
 */
const updateConditionValueType = (ruleIndex: number, conditionIndex: number, displayValue: string): void => {
  if (!props.isEditing) return;

  const valueType = getValueTypeByDisplayValue(displayValue);
  updateConditionByIndex(ruleIndex, conditionIndex, {
    valueType,
    value: valueType === 'number' ? null : '',
    validateError: {
      ...rulesForDrag.value[ruleIndex].conditions[conditionIndex].validateError,
      value: 'none',
    },
  });
};

/**
 * 数値条件値を更新する
 * @param ruleIndex - 更新対象のルールindex
 * @param conditionIndex - 更新対象の条件index
 * @param value - 入力値
 */
const updateNumberConditionValue = (ruleIndex: number, conditionIndex: number, value: string): void => {
  if (!props.isEditing) return;

  updateConditionByIndex(ruleIndex, conditionIndex, {
    value: value === '' ? null : Number(value),
  });
};

/**
 * 登録値を更新する
 * @param ruleIndex - 更新対象のルールindex
 * @param result - 登録値
 */
const updateRuleResult = (ruleIndex: number, result: OrderStatus): void => {
  if (!props.isEditing) return;

  emitRules(rulesForDrag.value.map((rule, index) => (index === ruleIndex ? { ...rule, result } : rule)));
};

/**
 * 条件に一致しない場合の発注ステータスを更新する
 * @param status - 発注ステータス
 */
const updateFallbackStatus = (status: OrderStatus): void => {
  if (!props.isEditing) return;

  emits('update:fallbackStatus', status);
};

/**
 * 発注ステータス条件のDnDキーを取得する
 * @param item - 発注ステータス条件
 * @returns 条件ID
 */
const getRuleKey = (item: ImportOrderStatusRule): string => item.id;

/**
 * DnDで並び替えたルールを親へ通知する
 */
const handleRulesReorder = (): void => {
  if (!props.isEditing) return;

  emitRules(rulesForDrag.value);
};

const {
  handleDragStart,
  handleDragEnd,
  handleDragOver,
  handleDragLeave,
  handleDragOverEnd,
  handleDragLeaveEnd,
  handleDrop,
  handleDropToEnd,
  isDragging,
  isDropTarget,
  isDragOverEnd,
} = useNativeDragReorder({
  items: rulesForDrag,
  getKey: getRuleKey,
  onReorder: handleRulesReorder,
});

const canStartRuleDrag = ref(false);

/**
 * ドラッグ開始前に、操作開始位置がハンドルかどうかを記録する
 * @param event - pointerdownイベント
 */
const prepareRuleDrag = (event: PointerEvent): void => {
  if (!props.isEditing) {
    canStartRuleDrag.value = false;
    return;
  }

  const target = event.target;
  canStartRuleDrag.value = target instanceof HTMLElement && Boolean(target.closest(DRAG_HANDLE_SELECTOR));
};

/**
 * ハンドルから開始した時だけ行ドラッグを許可する
 * @param event - dragstartイベント
 * @param item - ドラッグする条件
 */
const handleRuleDragStart = (event: DragEvent, item: ImportOrderStatusRule): void => {
  if (!props.isEditing) {
    event.preventDefault();
    return;
  }

  if (!canStartRuleDrag.value) {
    event.preventDefault();
    return;
  }

  handleDragStart(event, item);
  canStartRuleDrag.value = false;
};

/**
 * ドラッグ終了時にDnD状態を戻す
 */
const handleRuleDragEnd = (): void => {
  canStartRuleDrag.value = false;
  handleDragEnd();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('発注ステータスの設定')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('登録ファイル項目')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('条件')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('セル値')), 1),
            _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1))
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('登録値')), 1),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "order-status-rules__actions order-status-rules__actions--header" }, null, -1))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rulesForDrag.value, (rule, ruleIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rule.id,
          class: _normalizeClass(["order-status-rules__rule", {
          'order-status-rules__rule--dragging': _unref(isDragging)(rule),
          'order-status-rules__rule--drop-target': _unref(isDropTarget)(rule),
        }]),
          draggable: _ctx.isEditing,
          onPointerdown: prepareRuleDrag,
          onDragstart: ($event: any) => (handleRuleDragStart($event, rule)),
          onDragend: handleRuleDragEnd,
          onDragover: ($event: any) => (_unref(handleDragOver)($event, rule)),
          onDragleave: ($event: any) => (_unref(handleDragLeave)($event, rule)),
          onDrop: ($event: any) => (_unref(handleDrop)($event, rule))
        }, [
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(DragHandle, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_9)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rule.conditions, (condition, conditionIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: condition.id,
                  class: "order-status-rules__condition-row"
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(conditionIndex === 0 ? '' : _unref(t)('かつ')), 1),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createBlock(SelectableField, {
                          key: 0,
                          value: condition.header || undefined,
                          "selected-id": condition.header,
                          hint: _unref(t)('項目を選択'),
                          suggestions: _ctx.suggestions,
                          onUpdateValue: (e) => updateConditionByIndex(ruleIndex, conditionIndex, { header: e })
                        }, null, 8, ["value", "selected-id", "hint", "suggestions", "onUpdateValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(condition.header), 1)),
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(condition.validateError.header === 'notEmpty' ? _unref(t)('記入必須です') : '　'), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createBlock(SelectableField, {
                          key: 0,
                          value: getOperatorDisplayValue(condition.operator),
                          "selected-id": condition.operator,
                          suggestions: _unref(conditionOperatorSuggestions),
                          onUpdateValue: (e) => updateConditionOperator(ruleIndex, conditionIndex, getOperatorByDisplayValue(e))
                        }, null, 8, ["value", "selected-id", "suggestions", "onUpdateValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(getOperatorDisplayValue(condition.operator)), 1)),
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString('　')))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["order-status-rules__value-cell", { 'order-status-rules__value-cell--readonly': !_ctx.isEditing }])
                  }, [
                    (!_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(getConditionValueDisplayValue(condition)), 1))
                      : (isNoValueOperator(condition.operator))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "--"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(SelectableField, {
                                value: getValueTypeDisplayValue(condition.valueType),
                                "selected-id": `${condition.id}-value-type`,
                                suggestions: getConditionValueTypeSuggestions(condition.operator),
                                onUpdateValue: (e) => updateConditionValueType(ruleIndex, conditionIndex, e)
                              }, null, 8, ["value", "selected-id", "suggestions", "onUpdateValue"])
                            ]),
                            (condition.valueType === 'number')
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  value: condition.value ?? '',
                                  class: "order-status-rules__input",
                                  type: "number",
                                  placeholder: _unref(t)('入力してください'),
                                  onChange: (e) => updateNumberConditionValue(ruleIndex, conditionIndex, (e.target as HTMLInputElement).value)
                                }, null, 40, _hoisted_22))
                              : (condition.valueType === 'date')
                                ? (_openBlock(), _createBlock(ConditionDateInput, {
                                    key: 1,
                                    "model-value": condition.value,
                                    "onUpdate:modelValue": (value) => updateConditionByIndex(ruleIndex, conditionIndex, { value })
                                  }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock("input", {
                                    key: 2,
                                    value: condition.value ?? '',
                                    class: "order-status-rules__input",
                                    type: "text",
                                    placeholder: _unref(t)('入力してください'),
                                    onChange: 
                      (e) => updateConditionByIndex(ruleIndex, conditionIndex, { value: (e.target as HTMLInputElement).value })
                    
                                  }, null, 40, _hoisted_23))
                          ], 64)),
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(getConditionValueErrorMessage(condition)), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.isEditing)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "order-status-rules__icon-button",
                        "aria-label": _unref(t)('条件削除'),
                        onClick: ($event: any) => (removeCondition(ruleIndex, conditionIndex))
                      }, [
                        _createVNode(Mdi, { icon: "close" })
                      ], 8, _hoisted_25))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(OrderStatusFormSelectInput, {
                    key: 0,
                    label: "",
                    "model-value": rule.result,
                    index: ruleIndex,
                    options: SELECTABLE_ORDER_STATUS,
                    "onUpdate:modelValue": (e) => updateRuleResult(ruleIndex, e)
                  }, null, 8, ["model-value", "index", "onUpdate:modelValue"]))
                : (_openBlock(), _createBlock(OrderStatusBadge, {
                    key: 1,
                    "order-status-str": rule.result
                  }, null, 8, ["order-status-str"]))
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "order-status-rules__icon-button",
                    "aria-label": _unref(t)('ルール削除'),
                    onClick: ($event: any) => (removeRule(ruleIndex))
                  }, [
                    _createVNode(Mdi, {
                      icon: "delete",
                      variant: "outlined"
                    })
                  ], 8, _hoisted_28))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isEditing)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "order-status-rules__add-condition-button",
                  onClick: ($event: any) => (addCondition(ruleIndex))
                }, [
                  _createVNode(Mdi, { icon: "add" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('条件行を追加')), 1)
                ], 8, _hoisted_29))
              : _createCommentVNode("", true)
          ])
        ], 42, _hoisted_8))
      }), 128)),
      (_ctx.isEditing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["order-status-rules__end-drop-line", { 'order-status-rules__end-drop-line--active': _unref(isDragOverEnd) }]),
            onDragover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleDragOverEnd) && _unref(handleDragOverEnd)(...args))),
            onDragleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleDragLeaveEnd) && _unref(handleDragLeaveEnd)(...args))),
            onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleDropToEnd) && _unref(handleDropToEnd)(...args)))
          }, null, 34))
        : _createCommentVNode("", true),
      (_ctx.isEditing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "order-status-rules__add-rule-button",
            onClick: addRule
          }, [
            _createVNode(Mdi, { icon: "add" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('ルールを追加')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createTextVNode(_toDisplayString(_unref(t)('条件に一致しないものは全て')) + " ", 1),
      (_ctx.isEditing)
        ? (_openBlock(), _createBlock(OrderStatusFormSelectInput, {
            key: 0,
            label: "",
            "model-value": _ctx.fallbackStatus,
            index: FALLBACK_STATUS_SELECT_INDEX,
            options: SELECTABLE_ORDER_STATUS,
            "onUpdate:modelValue": updateFallbackStatus
          }, null, 8, ["model-value"]))
        : (_openBlock(), _createBlock(OrderStatusBadge, {
            key: 1,
            "order-status-str": _ctx.fallbackStatus
          }, null, 8, ["order-status-str"])),
      _createTextVNode(" " + _toDisplayString(_unref(t)('でシステムに登録する')), 1)
    ])
  ]))
}
}

})